module.exports = __webpack_public_path__ + "img/alabama-auto-logo.72d7fcdd.jpg";